<template>
  <default-step-container v-on="containerListeners" :required="false">
    <template #question>{{ question }}</template>
    <template #default>
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">
          <div v-if="state === 'sending'" class="alert alert-info text-center">
            Senden des Bewerbungsformulars.
          </div>
          <div v-if="state === 'failed'" class="alert alert-danger text-center">
            Das Antragsformular konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.
          </div>
          <div v-if="state === 'success'" class="alert alert-success text-center">
            Ihre Bewerbung wurde erfolgreich
            übermittelt. Vielen Dank! Wir prüfen Ihre Bewerbung und melden uns in den kommenden 10 Tagen
            bei Ihnen zurück.
          </div>
        </div>
      </div>
    </template>
  </default-step-container>
</template>
<script>
import DefaultStep from './DefaultStep'
import axios from 'axios'
import { lang, salaryFormatter, dateFormatter } from '../utils'

export default {
  extends: DefaultStep,

  data() {
    return {
      state: 'sending'
    }
  },

  mounted () {
    this.submit()
  },

  methods: {
    submit () {
      axios.post(process.env.VUE_APP_API, this.formAsPayload(), {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(() => this.success())
      .catch(this.failed)
    },

    formAsPayload () {
      let formData = new FormData()
      formData.append('data', JSON.stringify({
        salutation: this.form.salutation,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        street: `${this.form.street} ${this.form.house_number}`,
        postal: this.form.postal,
        city: this.form.city,
        phone: this.form.telephone_number,
        email: this.form.email,
        title: '',
        questions: [
          {
            label: lang.drivers_license,
            answer: this.form.drivers_license.join(', ')
          },
          {
            label: lang.entry_95,
            answer: this.form.license_and_entry_95.join(', ')
          },
          {
            label: lang.linquistic_proficiency,
            answer: [...this.form.languages, this.form.language_others].filter(i => i).join(', ')
          },
          {
            label: lang.possible_start_of_work,
            answer: dateFormatter(this.form.start_of_work)
          },
          {
            label: lang.salary_expectations,
            answer: salaryFormatter(this.form.expected_salary)
          },
          {
            label: lang.additional_information,
            answer: this.form.additional_information
          }
        ]
      }))

      if (this.form.file_upload instanceof FileList) {
        formData.append('file', this.form.file_upload[0])
      }

      return formData
    },

    failed (e) {
      this.state = 'failed'
      if (process.env.NODE_ENV === 'development') {
        console.log(e)
      }
    },

    success () {
      this.state = 'success'
    }
  }
}
</script>
